import styled from 'styled-components'

import HexagonDark from '@public/images/animated-icons/half-dark-hexagon.svg'
import TopHexagon from '@public/images/animated-icons/half-top-hexagon.svg'
import LargeTriangle from '@public/images/animated-icons/large-triangle.svg'
import TriangleSmall from '@public/images/animated-icons/triangle-small.svg'
import Triangle from '@public/images/animated-icons/triangle.svg'

export const BottomCatchTriangle = styled(Triangle)`
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
`
export const BottomCatchTriangleOrange = styled(Triangle)`
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  path {
    fill: ${({ theme }) => theme.colors.lightOrange};
  }
`
export const LeftSideTriangle = styled(TriangleSmall)`
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
`
export const TriangleSmallOrange = styled(TriangleSmall)`
  path {
    fill: ${({ theme }) => theme.colors.lightOrange};
  }
`
export const LeftSideTriangleOrange = styled(TriangleSmall)`
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
  path {
    fill: ${({ theme }) => theme.colors.lightOrange};
  }
`
export const TopTriangle = styled(Triangle)`
  path {
    fill: ${({ theme }) => theme.colors.lightOrange};
  }
`
export const TopHexagonOrange = styled(TopHexagon)`
  path {
    stroke: ${({ theme }) => theme.colors.lightOrange};
  }
`
export const LargeTriangleOrange = styled(LargeTriangle)`
  path {
    fill: ${({ theme }) => theme.colors.lightOrange};
  }
`
export const AdvantagesSectionWrapper = styled.div`
  margin-top: ${({ theme }) => theme.newSpaces.xl3}px;
`
export const TopHexagonDark = styled(HexagonDark)`
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
`
